function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 36,
  r: 32.825,
  stroke: "currentColor",
  strokeWidth: 2.85
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.174 35.047l10.55 10.55 21.103-19.195",
  stroke: "#000",
  strokeWidth: 2.85,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgChecklistLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 72",
    fill: "none"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB2aWV3Qm94PSIwIDAgNzIgNzIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxjaXJjbGUgY3g9IjM2IiBjeT0iMzYiIHI9IjMyLjgyNSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMi44NSIvPgo8cGF0aCBkPSJNMjAuMTczOCAzNS4wNDY2TDMwLjcyNDkgNDUuNTk3N0w1MS44MjcgMjYuNDAyMyIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyLjg1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgChecklistLarge as ReactComponent };